import React from 'react';
import { Button, useToast } from '@chatsdet/ui';
import { Copy, CircleNotch } from '@phosphor-icons/react';

type DebugPromptButtonProps = {
  issueId: string;
  apiUrl: string;
};

export function DebugPromptButton({ issueId, apiUrl }: DebugPromptButtonProps) {
  const [isCopying, setIsCopying] = React.useState(false);
  const { toast } = useToast();

  const handleCopy = async () => {
    setIsCopying(true);
    try {
      const response = await fetch(`${apiUrl}/v2/issues/${issueId}/debug-prompt`, {
        credentials: 'include',
      });
      if (!response.ok) {
        throw new Error('Failed to fetch debug prompt');
      }
      const text = await response.text();
      await navigator.clipboard.writeText(text);
      toast.success('Debug prompt copied');
    } catch {
      toast.error('Failed to copy debug prompt');
    } finally {
      setIsCopying(false);
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      iconLeft={isCopying ? <CircleNotch size={16} className="animate-spin" /> : <Copy size={16} />}
      isDisabled={isCopying}
      onPress={handleCopy}
    >
      Copy Debug Prompt
    </Button>
  );
}
